export default __webpack_public_path__ + "static/media/img01.a8c19c50.jpg";